import { createAction, props } from '@ngrx/store';

export const setSelectedOrderId = createAction('[Orders] Set Selected Order Id', props<{ orderId: number }>());
